import { CampayService } from './campayService';
import { PaymentProvider } from './paymentProvider';
import { PaymentRequest } from '../../types/payment';
import { generateReference } from '../../utils/referenceGenerator';

export class PaymentService {
  private provider: PaymentProvider;

  constructor() {
    this.provider = new CampayService();
  }

  async initializeVotePayment(params: {
    contestantId: string;
    amount: number;
    phoneNumber: string;
    votes: number;
  }) {
    const reference = generateReference();
    
    const request: PaymentRequest = {
      amount: params.amount,
      phoneNumber: params.phoneNumber,
      description: `Vote pour le candidat (${params.votes} votes)`,
      reference
    };

    return this.provider.initializePayment(request);
  }

  async verifyPayment(reference: string) {
    return this.provider.verifyPayment(reference);
  }
}